import '../fake-db';
import { Provider } from 'react-redux';
import { useRoutes } from 'react-router-dom';
import { MatxTheme } from './components';
import { AuthProvider } from './contexts/JWTAuthContext';
import { SettingsProvider } from './contexts/SettingsContext';
import { SnackbarProvider } from "notistack";
import { Store } from './redux/Store';
import routes from './routes';

const snackbarOptions = {
  vertical: 'top',
  horizontal: 'center',
}

const App = () => {
  const content = useRoutes(routes);

  return (
    <Provider store={Store}>
      <SettingsProvider>
        <MatxTheme>
          <SnackbarProvider anchorOrigin={snackbarOptions} maxSnack={3} autoHideDuration={3000}>
            <AuthProvider>{content}</AuthProvider>
          </SnackbarProvider>
        </MatxTheme>
      </SettingsProvider>
    </Provider>
  );
};

export default App;
